import React from 'react';
import PropTypes from 'prop-types';
import ExternalLinkIcon from 'components/v2/icons/ExternalLinkIcon';
export default function ShipmentLink({ shipment }) {
    return (React.createElement("a", { className: "underline", href: `/shipments/${shipment === null || shipment === void 0 ? void 0 : shipment._id}`, target: "_blank", rel: "noreferrer noopener" },
        React.createElement("div", { className: "flex items-center space-x-1" },
            React.createElement("span", null, shipment === null || shipment === void 0 ? void 0 : shipment.shipment_id),
            React.createElement(ExternalLinkIcon, { className: "w-4 h-4" }))));
}
ShipmentLink.propTypes = {
    actionItem: PropTypes.shape({
        _id: PropTypes.string,
        shipment_id: PropTypes.string,
    }),
};
ShipmentLink.defaultProps = {
    actionItem: {},
};
